import type { CSSObjectWithLabel } from 'react-select';

const SELECT_MENU_PORTAL_ID = 'select-menu-portal';

export function getSelectMenuPortalTarget(): HTMLElement | undefined {
  if (typeof document === 'undefined') return undefined;

  const existingPortal = document.getElementById(SELECT_MENU_PORTAL_ID);
  if (existingPortal) return existingPortal;

  const portal = document.createElement('div');
  portal.id = SELECT_MENU_PORTAL_ID;
  // меню react-select рендерится вне компонента, поэтому добавляем .Select,
  // чтобы портальное меню подхватывало китовые стили, в том числе цвета темной темы
  portal.className = 'Select';
  document.body.appendChild(portal);

  return portal;
}

/** Порталит меню react-select в body и поднимает над модалками/поповерами. */
export const selectMenuPortalStyles = {
  menuPortal: (base: CSSObjectWithLabel): CSSObjectWithLabel => ({
    ...base,
    zIndex: 'var(--z-index-popover)',
  }),
};

export const selectMenuPortalProps = {
  get menuPortalTarget(): HTMLElement | undefined {
    return getSelectMenuPortalTarget();
  },
  styles: selectMenuPortalStyles,
};
